<div class="restaurant-item">
  <img [src]="imageLogoUrl" [alt]="name">
  <p>{{ name }}</p>
</div>
